import React, { useEffect, useState } from "react";
import { FormControl, Grid, Typography, Select, MenuItem, InputAdornment } from "@mui/material";
import { Controller } from "react-hook-form";
import './PhoneField.css';
import { CustomStyledTextField } from "./ColoredTextfield";

let countryListModulePromise = null;
export function loadCountryListModule() {
  if (!countryListModulePromise) {
    countryListModulePromise = Promise.all([
      import('country-list-with-dial-code-and-flag'),
      import('country-list-with-dial-code-and-flag/dist/flag-svg')
    ]).then(([cl, svg]) => ({
      CountryList: cl.default || cl,
      CountryFlagSvg: svg.default || svg
    })).catch(err => {
      console.error("Error loading country-list module:", err);
      countryListModulePromise = null;
      throw err;
    });
  }
  return countryListModulePromise;
}

export default function PhoneField({ callback, countryCode, phone, disabled, manageUsersFlag, creditFlag, labelReq, errorMsgReg, customStyleClass }) {
  const [first, setfirst] = useState([])
  const [Country, setCountry] = useState("IN")
  const [DefaultCountry, setDefaultCountry] = useState([])
  const [DialCode, setDialCode] = useState([])
  const [PhoneNumber, setPhoneNumber] = useState("")
  const [Error, setError] = useState("")
  const [MaxLength, setMaxLength] = useState(10);
  const [isCountryLoaded, setIsCountryLoaded] = useState(false)

  useEffect(() => {
    let isMounted = true;
    loadCountryListModule().then(({ CountryList, CountryFlagSvg }) => {
      if (!isMounted) return;
      const defaultcountry = CountryList.findOneByCountryCode('in')
      const country = CountryList.getAll()
      if (defaultcountry) {
        setDefaultCountry(`data:image/svg+xml;utf8,${encodeURIComponent(CountryFlagSvg[defaultcountry.code])}`)
        setDialCode(defaultcountry.dialCode)
        setfirst(country)
      }
    }).catch(console.error);
    return () => { isMounted = false; };
  }, [])

  useEffect(() => {
    if (countryCode) {
      let isMounted = true;
      loadCountryListModule().then(({ CountryList, CountryFlagSvg }) => {
        if (!isMounted) return;
        const defaultCountry = CountryList.findOneByDialCode(countryCode);
        if (defaultCountry) {
           setIsCountryLoaded(true)
          setDefaultCountry(`data:image/svg+xml;utf8,${encodeURIComponent(CountryFlagSvg[defaultCountry.code])}`);
          setDialCode(defaultCountry.dialCode);
          setCountry(countryCode);
          if (phone) {
            setPhoneNumber(phone);
          }
          if (defaultCountry.dialCode === "+91") {
            setMaxLength(10);
          } else {
            setMaxLength(15);
          }
        }
      }).catch(console.error);
      return () => { isMounted = false; };
    }
  }, [countryCode, phone]);

  const selectCountry = (e) => {
    const val = e.target.value;
    setCountry(val);
    loadCountryListModule().then(({ CountryList, CountryFlagSvg }) => {
      let img = CountryList.findOneByCountryCode(val);
      if (img.dialCode === "+91") {
        setMaxLength(10)
      } else {
        setMaxLength(15)
      }
      setDialCode(img.dialCode)
      setDefaultCountry(`data:image/svg+xml;utf8,${encodeURIComponent(CountryFlagSvg[img.code])}`)
      setError("")
      setPhoneNumber("")
    }).catch(console.error);
  }

  function trimStr(str) {
    if (!str) return str;
    return str.replace(/^\s+/g, "");
  }
  const validatePhoneNumber = (e) => {
    SetCursorPointerPosition(e)
    if (DialCode === "+91" && trimStr(e.target.value).length > 10) {
      return setPhoneNumber(e.target.value.slice(0, 10));
    }
    else if (DialCode !== "+91" && trimStr(e.target.value).length > 15) {
      return setPhoneNumber(e.target.value.slice(0, 15));
    }
    if (DialCode === "+91" && (e.target.value.length > 10 || (e.target.value.length !== 0 && e.target.value.length !== 10))) {
      setError("Enter Valid Phone Number (10 Digits)")
    }
    else if (DialCode !== "+91" && ((e.target.value?.length > 15 || e.target.value?.length < 7) && e.target.value?.length !== 0)) {
      setError("Enter Valid Phone Number (7-15 Digits)")
    } else {
      setError("")
    }
    setPhoneNumber(e.target.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1'))
  }

  const SetCursorPointerPosition = (e) => {
    const Position = e.target.selectionStart;
    setTimeout(() => {
      e.target.setSelectionRange(Position, Position);
    }, 0);
  };

  useEffect(() => {
    if (isCountryLoaded) {
      callback({
        error: Error,
        number: PhoneNumber,
        code: DialCode
      })
    }
  }, [DialCode, PhoneNumber, Error, isCountryLoaded])

  return (
    <>
      <div className={'input_wrapper ' + customStyleClass} style={(manageUsersFlag || creditFlag) ? { marginBottom: '-5px', marginTop: '0px', width: '100%' } : {}}>
        {labelReq !== false ?
          <p className="label_styles" style={manageUsersFlag ? { fontSize: '12px' } : {}}>Phone Number</p> : null
        }
        <div className='phoneField'>
          <div className='countrySelect' style={manageUsersFlag ? { height: '23px' } : {}}>
            <img id="myImg" src={DefaultCountry} width="107" height="98" alt='' />
            <select id='check' value={Country} disabled={disabled && disabled} onChange={(e) => selectCountry(e)}>
              <option selected disabled>Country</option>
              {first?.map((d, i) => {
                return <option value={d.code} key={i}>
                  {d.name}
                </option>
              })}
            </select>
          </div>

          <span className='phoneFieldCode'>{DialCode}</span>
          <input type='text' style={{ backgroundColor: 'transparent', overflow: 'hidden' }} className='phoneFieldInput' placeholder='Enter Your Phone Number' disabled={disabled && disabled} maxLength={MaxLength} value={PhoneNumber} onChange={(e) => validatePhoneNumber(e)}></input>
        </div>
        <p className='help is-input-danger-message' style={{ fontSize: '11.4px' }}>{
          Error ? Error : <span>&nbsp;</span>
        }</p>
      </div>
    </>
  );
}

export function PhoneFieldnew({
  control,
  name,
  label = "Phone Number",
  rules,
  disabled,
  callback,
  countryCode,
  phone,
  mandatory = false,
  labelStyle,
  rest,
  fontSize,
  height,
  alignItems,
  textfieldStyles
}) {

  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("IN");
  const [dialCode, setDialCode] = useState("+91");
  const [maxLength, setMaxLength] = useState(10);

  useEffect(() => {
    let isMounted = true;
    loadCountryListModule().then(({ CountryList }) => {
      if (!isMounted) return;
      const all = CountryList.getAll();
      setCountries(all);

      const defaultCountry = CountryList.findOneByCountryCode("IN");
      if (defaultCountry) {
        setDialCode(defaultCountry.dialCode);
      }
    }).catch(console.error);
    return () => { isMounted = false; };
  }, []);

  useEffect(() => {
    if (countryCode) {
      let isMounted = true;
      loadCountryListModule().then(({ CountryList }) => {
        if (!isMounted) return;
        const c = CountryList.findOneByDialCode(countryCode);
        if (c) {
          setCountry(c.code);
          setDialCode(c.dialCode);
          setMaxLength(c.dialCode === "+91" ? 10 : 15);
        }
      }).catch(console.error);
      return () => { isMounted = false; };
    }
  }, [countryCode]);

  const handleCountryChange = (value) => {
    loadCountryListModule().then(({ CountryList }) => {
      const selected = CountryList.findOneByCountryCode(value);
      if (selected) {
        setCountry(value);
        setDialCode(selected.dialCode);
        setMaxLength(selected.dialCode === "+91" ? 10 : 15);
      }
    }).catch(console.error);
  };

  const validatePhone = (value) => {
    let num = value.replace(/[^0-9]/g, "");

    if (dialCode === "+91" && num.length > 10) {
      num = num.slice(0, 10);
    } else if (dialCode !== "+91" && num.length > 15) {
      num = num.slice(0, 15);
    }

    return num;
  };

  return (
    <FormControl fullWidth>
      <Controller
        name={name}
        control={control}
        rules={{
          ...rules,
          validate: (value) => {
            if (!value) return true;

            if (dialCode === "+91" && value.length !== 10) {
              return "Enter valid 10 digit number";
            }

            if (dialCode !== "+91" && (value.length < 7 || value.length > 15)) {
              return "Enter valid number (7-15 digits)";
            }

            return true;
          },
        }}
        defaultValue={phone || ""}
        render={({ field, fieldState }) => (

          <Grid container rowSpacing={1}>

            {/* Label */}
            <Grid item xs={12}>
              <Typography style={{ textAlign: "start", fontFamily: "Figtree", ...labelStyle }}>{label}</Typography>
            </Grid>
            <Grid item xs={12}>
              <CustomStyledTextField
                {...field}
                disabled={disabled}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                fullWidth
                size="small"
                variant="outlined"
                inputProps={{ maxLength }}
                {...rest}

                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Select
                        value={country}
                        onChange={(e) => handleCountryChange(e.target.value)}
                        variant="standard"
                        disableUnderline
                        disabled={disabled}
                      >
                        {countries.map((c, i) => (
                          <MenuItem key={i} value={c.code}>
                            {c.dialCode}
                          </MenuItem>
                        ))}
                      </Select>
                    </InputAdornment>
                  ),

                  style: {
                    backgroundColor: "white",
                    fontSize: fontSize || "16px",
                    height: height,
                    alignItems: alignItems,
                    ...textfieldStyles,
                  }
                }} sx={{
                  padding: 0, margin: 0,
                  '& .MuiOutlinedInput-root': {
                    padding: "0px !important",
                    paddingRight: "0px !important"
                  },
                  "& .MuiFormControl-root .MuiTextField-root": {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: "center",
                    padding: "0px !important"
                  },
                  "& .MuiInputAdornment-positionEnd": {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  },
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused": {
                      fieldset: {
                        borderColor: `${process.env.REACT_APP_ENTERPRISE_COLOUR} !important`,
                      },
                    },
                    "&.Mui-error": {
                      "&.Mui-focused": {
                        fieldset: {
                          borderColor: 'red !important',
                        },
                      },
                    },
                    "&.Mui-invalid": {
                      fieldset: {
                        border: 'red !important',
                      },
                    },
                  },
                }}

                onChange={(e) => {
                  const value = validatePhone(e.target.value);
                  field.onChange(value);

                  if (callback) {
                    callback({
                      number: value,
                      code: dialCode,
                      error: fieldState.error,
                    });
                  }
                }}
              />
            </Grid>
          </Grid>
        )}
      />
    </FormControl>
  );
}
